exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3znHXjVFnc0qDe4Ofm1G03{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._3znHXjVFnc0qDe4Ofm1G03>:not(:first-of-type){margin-top:1.07143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"LanguageRadio": "_3znHXjVFnc0qDe4Ofm1G03"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/LanguageRadio/style.postcss
// module id = 1502
// module chunks = 0